import dayjs from "dayjs";

/**
 * Konvertiert einen Datumswert (Dayjs/Date/ISO-String/Timestamp) in einen lokalen `YYYY-MM-DD`-String
 * für API-Queries/Payloads. Ungültig/leer → null. Kanonische Quelle (vormals 5× dupliziert).
 */
export function formatDateOnlyIso(value?: unknown | null): string | null {
  if (!value) return null;
  try {
    if (typeof value !== "string" && typeof value !== "number" && !(value instanceof Date) && !dayjs.isDayjs(value)) {
      return null;
    }
    const d = dayjs(value as dayjs.ConfigType);
    return d.isValid() ? d.format("YYYY-MM-DD") : null;
  } catch {
    return null;
  }
}
